import React, { memo, useContext } from 'react';
import './css/HomePage1Section6.css';
import HomePage1About from '../uiElements/homePage1About/HomePage1About';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { context } from '../../../../globalState/GlobalState';

const HomePage1Section6 = () => {
    const { globalState } = useContext(context);

    return (
        <>
            {isValidObject(globalState.teamInfo) && isValidString(globalState.teamInfo.shortAbout) ? (
                <div className="homepage1-section6-container full-width m-t-50px m-b-50px">
                    <HomePage1About />
                </div>
            ) : null}
        </>
    );
};

export default memo(HomePage1Section6);
